import React from "react";
import * as Styled from "./styles.js";

function AlignmentItem({ image, isSelected, onClick, isActive }) {
  return (
    <Styled.Container
      isSelected={isSelected}
      onClick={onClick}
      width="165px"
      isActive={isActive}
    >
      <Styled.AlignmentImage src={image} alt="size"></Styled.AlignmentImage>
    </Styled.Container>
  );
}

export default AlignmentItem;
